var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"success"}},[_c('div',{staticClass:"error"}),_c('h5',[_vm._v("出错啦！")]),_c('div',{staticClass:"btn-main btn-home"},[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("返回首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }